import { Col, Container, Row, Stack } from "react-bootstrap"

const HireFrontendDeveloperContent = () => {  
    return (
                
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>Hire Frontend Developers to Build Stunning, Responsive Web Interfaces</h2>
                        <p>
                            Looking to craft visually appealing and high-performance websites or web applications? Our expert frontend developers are here to bring your ideas to life with pixel-perfect precision and seamless user experiences.
                        </p>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>Why Hire Frontend Developers from Us?</h2>
                            <ul>
                                <li>
                                    <b>Skilled in Modern Technologies</b>
                                    <p>
                                        Proficient in HTML5, CSS3, JavaScript, React, Angular, Vue.js, and more.
                                    </p>
                                </li>
                                <li>
                                    <b>Responsive & Cross-Browser Compatibility</b>
                                    <p>
                                        We ensure your site looks perfect across all devices and browsers.
                                    </p>
                                </li>
                                <li>
                                    <b>UI/UX Focused Development</b>
                                    <p>
                                        We build with the user in mind — intuitive, interactive, and optimized for engagement.
                                    </p>
                                </li>
                                <li>
                                    <b>Fast Turnaround Time</b>
                                    <p>
                                        Get your frontend projects delivered on time without compromising quality.
                                    </p>
                                </li>
                                <li>
                                    <b>Customizable Engagement Models</b>
                                    <p>
                                        Hire developers on an hourly, part-time, or full-time basis — tailored to your project needs.
                                    </p>
                                </li>
                            </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>Our Frontend Development Services</h2>
                        <ul>
                            <li>PSD/Figma to HTML Conversion</li>
                            <li>Custom Web App UI Development</li>
                            <li>Single Page Application (SPA) Development</li>
                            <li>React/Angular/Vue Component Development</li>
                            <li>Performance Optimization & Maintenance</li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>Ready to Get Started?</h2>
                        <p>
                            Let’s discuss your project and help you find the perfect AngularJS developer. Contact us today to get a free consultation and quote.
                        </p>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}

export default HireFrontendDeveloperContent;